// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2UEty","content":"ManualTimeModal_content__1Jxns"};